import type { ReactNode } from 'react';
import type { SyncLogRow } from '@tally/lib/types';

export function SourceCard({
  name,
  sync,
  items,
  children,
}: {
  name: string;
  sync?: SyncLogRow;
  items: string[];
  children?: ReactNode;
}) {
  const status = sync?.status ?? 'manual';
  const statusClass =
    status === 'ok' ? 'text-emerald-400'
    : status === 'stale' ? 'text-amber-400'
    : status === 'error' ? 'text-rose-400'
    : 'text-stone-500';
  return (
    <div className="border border-stone-800 p-4">
      <div className="flex items-baseline justify-between mb-3">
        <div className="text-sm text-stone-100">{name}</div>
        <div className={`text-[9px] uppercase tracking-[0.2em] font-mono ${statusClass}`}>{status}</div>
      </div>
      <div className="space-y-1">
        {items.map((item) => (
          <div key={item} className="text-[11px] text-stone-400 font-mono">· {item}</div>
        ))}
      </div>
      {children && <div className="mt-3">{children}</div>}
      {sync?.message && <div className="text-[10px] text-stone-600 font-mono mt-3 truncate" title={sync.message}>{sync.message}</div>}
    </div>
  );
}
